import type { FC } from 'react';
import { Card, Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderGestion from 'src/components/global/TableCellHeaderGestion';
import Loading from 'src/components/global/Loading';
import { formatNumber } from 'src/utils/functions';

const FunnelResumen: FC<any> = ({ data, spinner }) => (
  <>
    <Grid container spacing={2} mt={2}>
      <Grid item xl={12} md={12} xs={12}>
        <Title title="Resumen de gestión del dia" align="left" />
      </Grid>
      <Grid item xl={10} md={12} xs={12}>
        <Card>
          <Scrollbar>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCellHeaderGestion>
                    Cierre del dia
                  </TableCellHeaderGestion>
                  <TableCellHeaderGestion width={100} align="right">
                    Número de Operaciones
                  </TableCellHeaderGestion>
                  <TableCellHeaderGestion width={100} align="right">
                    Monto
                  </TableCellHeaderGestion>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  spinner && (
                    <TableRow>
                      <TableCell colSpan={3}>
                        <Loading />
                      </TableCell>
                    </TableRow>
                  )
                }
                {
                  !spinner && data.map((item) => {
                    const key = `rowKey-${item.id}`;
                    return (
                      <TableRow key={key}>
                        <TableCell>
                          {item.titulo}
                        </TableCell>
                        <TableCell align="right">
                          {item.cantidad}
                        </TableCell>
                        <TableCell align="right">
                          { formatNumber(item.monto)}
                        </TableCell>
                      </TableRow>
                    );
                  })
                }
              </TableBody>
            </Table>
          </Scrollbar>
        </Card>
      </Grid>
    </Grid>
  </>
);

export default FunnelResumen;
